/**
 * Pulls the message out of a failed college-library request. The backend's error envelope
 * (`ErrorResponse`) names the field `errorMessage`, so reading `message` would silently discard
 * every specific rejection ("Only PDF files can be uploaded here", "This folder still has files
 * in it", "Files must be 25 MB or smaller") and show only the generic fallback.
 */
export const libraryErrorMessage = (error, fallback) =>
  error?.response?.data?.errorMessage || error?.response?.data?.message || fallback;
